import { getPepperAddress } from '@/config/get-pepper-address'
import { NetworkId } from '@/types/network'
import { useChainId } from 'wagmi'

/**
 * Fetches the address of the Pepper contract according to the current chain
 * @returns The address of the Pepper contract
 */
export function usePepperContractAddress() {
	const chainId = useChainId()

	return getPepperAddress(chainId as NetworkId)
}

const SYMBOL_MAP = {
	88888: 'PEPPER',
	88881: 'PEPPER',
	default: 'PPR'
}

export function usePepperTokenConfig() {
	const chainId = useChainId()

	return {
		address: getPepperAddress(chainId as NetworkId),
		symbol: SYMBOL_MAP[chainId] ?? SYMBOL_MAP.default,
		decimals: 18,
		image: 'https://assets-staking.chiliz.com/images/assets/pepper.webp'
	}
}
